import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, Outlet, useLocation } from "react-router-dom";
import { getWord } from "../../utils/functions";
import Login from "../Common/Login";
import { logoutUser } from "../../helpers/auth";

const routeTitles = {
  "/user/orders": getWord("My Orders"),
  "/user/order/:id": getWord("Order Information"),
  "/user/profile": getWord("Update Profile"),
  "/user/addresses": getWord("My Addresses"),
  "/user/address/": getWord("Add Address"),
  "/user/address/:id": getWord("Update Address"),
  "/user/track": getWord("Track order"),
  "/user/change-password": getWord("Change Password"),
};

const MyAccount = () => {
  const user = useSelector((state) => state.user);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const location = useLocation();
  const [title, setTitle] = useState("My Account");

  useEffect(() => {
    const path = location.pathname;
    const matchedTitle = routeTitles[path] || getWord("My Account");
    setTitle(matchedTitle);
  }, [location]);

  const openLogin = () => setIsLoginOpen(true);
  const closeLogin = () => setIsLoginOpen(false);
  return (
    <>
      <div className="tf-page-title">
        <div className="container-full">
          <div className="row">
            <div className="col-12">
              <div className="heading text-center">{title}</div>
            </div>
          </div>
        </div>
      </div>

      <section className="flat-spacing-1">
        <div className="container">
          <div className="blog-sidebar-main p-0">
            <div className="tf-section-sidebar wrap-sidebar-mobile flex-shrink-0">
              <div id="facet-filter-form" className="facet-filter-form">
                <div className="widget-facet">
                  <div id="size" className="collapse show">
                    <ul className="tf-filter-group">
                      {user.isLoggedIn ? (
                        <>
                          <li className="list-item d-flex gap-12 align-items-center <?= activateMenu('my-account">
                            <Link to="dashboard">
                              <span>{getWord("Dashboard")}</span>
                            </Link>
                          </li>
                          <li className="list-item d-flex gap-12 align-items-center">
                            <Link to="orders">
                              <span>{getWord("My Orders")}</span>
                            </Link>
                          </li>
                          <li className="list-item d-flex gap-12 align-items-center">
                            <Link to="addresses">
                              <span>{getWord("My Addresses")}</span>
                            </Link>
                          </li>
                          <li className="list-item d-flex gap-12 align-items-center">
                            <Link to="track">
                              <span>{getWord("Track Order")}</span>
                            </Link>
                          </li>
                          <li className="list-item d-flex gap-12 align-items-center">
                            <Link to="profile">
                              <span>{getWord("Update Profile")}</span>
                            </Link>
                          </li>
                          <li className="list-item d-flex gap-12 align-items-center">
                            <Link to="change-password">
                              <span>{getWord("Change Password")}</span>
                            </Link>
                          </li>
                          <li className="list-item d-flex gap-12 align-items-center">
                            <a onClick={logoutUser}>
                              <span>{getWord("Logout")}</span>
                            </a>
                          </li>
                        </>
                      ) : (
                        <>
                          <li className="list-item d-flex gap-12 align-items-center">
                            <Link to="track">
                              <span>{getWord("Track Order")}</span>
                            </Link>
                          </li>
                          <li className="list-item d-flex gap-12 align-items-center">
                            <>
                              <a data-bs-toggle="modal" onClick={openLogin}>
                                <span>{getWord("Login")}</span>
                              </a>
                              <Login
                                isOpen={isLoginOpen}
                                onClose={closeLogin}
                              ></Login>
                            </>
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="btn-sidebar-mobile start-0">
              <a
                href="#filterShop"
                data-bs-toggle="offcanvas"
                aria-controls="offcanvasLeft"
              >
                <button className="type-hover">
                  <i className="icon-open"></i>
                  <span className="fw-5">{getWord("Open Sidebar")}</span>
                </button>
              </a>
            </div>
            <div
              className="offcanvas offcanvas-start canvas-filter"
              id="filterShop"
            >
              <div className="canvas-wrapper">
                <header className="canvas-header">
                  <div className="filter-icon">
                    <span>{getWord("My Account")}</span>
                  </div>
                  <span
                    className="icon-close icon-close-popup"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></span>
                </header>
                <div className="canvas-body">
                  <div className="sidebar-mobile-append tf-section-sidebar"></div>
                </div>
              </div>
            </div>
            <Outlet></Outlet>
          </div>
        </div>
      </section>
    </>
  );
};

export default MyAccount;
